class MyRlinkController {
  constructor (Localization, RegistrationHelper, $state, $stateParams, I18n, StoreTypes) {
    'ngInject'
    this.$state = $state
    this.$stateParams = $stateParams
    this.RegistrationHelper = RegistrationHelper
    this.I18n = I18n
    this.type = Localization.getLocalizedAppConfig().type
    this.StoreTypes = StoreTypes
    this.rlinkModels = Localization.getLocalizedAppConfig().rlinkModels

    this.checkStep1Params()
    this.checkStep2Params()
  }

  /**
   * Verify state params relative to step 1 - My Profile : civility, first name, last name, email, mobile phone
   * If one of these is incorr, the user is redirected to step 1
   */
  checkStep1Params () {
    if (!this.RegistrationHelper.checkCivility(this.$stateParams.civility) ||
        !this.$stateParams.firstName || !this.$stateParams.lastName ||
        !this.RegistrationHelper.checkEmail(this.$stateParams.email) ||
        !this.$stateParams.password
      ) {
      return this.$state.go('registration.myProfile', { profile: undefined })
    } else {
      this.profile = {
        civility: this.$stateParams.civility,
        firstName: this.$stateParams.firstName,
        lastName: this.$stateParams.lastName,
        email: this.$stateParams.email,
        password: this.$stateParams.password
      }
    }
  }

  /**
   * Verify state params relative to step 2 - My Rlink
   *
   * @return {Promise} set the model if it has already been selected
   */
  checkStep2Params () {
    if (this.$stateParams.model && this.RegistrationHelper.checkModel(this.$stateParams.model, this.rlinkModels)) {
      this.model = this.$stateParams.model
    } else if (this.$stateParams.model) {
      return this.$state.go('registration.myRlink', { model: undefined })
    }
  }

  backToStep1 () {
    return this.$state.go('registration.myProfile',
      {
        civility: this.$stateParams.civility,
        firstName: this.$stateParams.firstName,
        lastName: this.$stateParams.lastName,
        email: this.$stateParams.email,
        password: this.$stateParams.password,
        model: this.model,
        friendlyName: this.$stateParams.friendlyName,
        vin: this.$stateParams.vin
      })
  }

  submit () {
    var params = {}
    if (this.model === this.$stateParams.model) {
      params = {
        model: this.model,
        friendlyName: this.$stateParams.friendlyName,
        vin: this.$stateParams.vin,
        civility: this.$stateParams.civility,
        firstName: this.$stateParams.firstName,
        lastName: this.$stateParams.lastName,
        email: this.$stateParams.email,
        password: this.$stateParams.password
      }
    } else {
      params = {
        model: this.model,
        civility: this.$stateParams.civility,
        firstName: this.$stateParams.firstName,
        lastName: this.$stateParams.lastName,
        email: this.$stateParams.email,
        password: this.$stateParams.password
      }
    }
    return this.$state.go('registration.myToolbox', params)
  }

  get isIframe () {
    return (this.type === this.StoreTypes.HELIOS ||
      this.type === this.StoreTypes.MYRENAULT ||
      this.type === this.StoreTypes.RSITE ||
      this.type === this.StoreTypes.ONE)
  }

}
export default MyRlinkController



// WEBPACK FOOTER //
// ./src/app/pages/registration/my-rlink/my-rlink.controller.js